import React from 'react'
import { useReportCrossClientResultsView } from './hooks'

export interface CrossClientResultsViewReporterProps {
  executionId: string
}

export const CrossClientResultsViewReporter: React.FC<CrossClientResultsViewReporterProps> = ({ executionId }) => {
  useReportCrossClientResultsView(executionId)
  return null
}
